/*
|----------------------------------------------------------
|   Audio Stream Player:
|---------------------------------------------------------
|   All functions related to the WPB Audio Stream manager
|
*/

/**
 * Import config
 */
import config from "./config";

/**
 * Opens and closes flyout trays
 */

const $btnFlyout = jQuery('.audio-player-flyout-btn');
const $trayFlyout = jQuery('#audio-player-flyout');
const $btnStationFlyout = jQuery('.audio-player-streams-btn');
const $trayStationFlyout = jQuery('#audio-player-station-streams-flyout');


const toggleFlyout = function () {
    $trayFlyout.toggleClass('open');
    $btnFlyout.toggleClass('open');
    if ($trayStationFlyout.hasClass('open') && $btnStationFlyout.hasClass('open')) {
        $trayStationFlyout.removeClass('open');
        $btnStationFlyout.removeClass('open');
    }


}

const toggleStationFlyout = function () {
    $trayStationFlyout.toggleClass('open');
    $btnStationFlyout.toggleClass('open');
    if ($trayFlyout.hasClass('open') && $btnFlyout.hasClass('open')) {
        $trayFlyout.removeClass('open');
        $btnFlyout.removeClass('open');
    }

}

export default {

    /**
     * Audio player flyout open/close button.
     */
    flyoutBtn: function() {
        if (config.debug) console.log("flyoutBtn() click");
        var classes = '.audio-player-flyout-btn, .show-toggle-flyout .on-air-now .listen-btn, .toggle-flyout';
        var $btn = jQuery(classes);

        /**
         * Sets the buttons when hash in URL
         * on page load
         */
        if(window.location.hash === '#audio-player-flyout'){
            jQuery('#audio-player-flyout').addClass('open');
            $btn.addClass('open');
        }

        jQuery(document).on('click', classes, function(e){
            e.preventDefault();
            toggleFlyout();
        })
    },

    closeFlyout: function() {
        if (config.debug) console.log("closeFlyout");
        $trayFlyout.removeClass('open');
        $btnFlyout.removeClass('open');
    },

    /**
     * Audio player stations flyout open/close button.
     */
    flyoutStationsBtn: function() {
        if (config.debug) console.log("flyoutBtn() click");
        var classes = '.audio-player-streams-btn, .show-toggle-flyout .on-air-now .listen-btn, .toggle-stations-flyout';
        var $btn = jQuery(classes);

        /**
         * Sets the buttons when hash in URL
         * on page load
         */
        if(window.location.hash === '#audio-player-stations-flyout'){
            jQuery('#audio-player-station-streams-flyout').addClass('open');
            $btn.addClass('open');
        }

        jQuery(document).on('click', classes, function(e){
            e.preventDefault();
            toggleStationFlyout();
        })

        jQuery(document).on('click', '#audio-player-station-streams-flyout .station-item-link', function (e) {
            e.preventDefault();
            toggleStationFlyout();
        })
    },

    closeStationsFlyout: function() {
        if (config.debug) console.log("closeStationsFlyout");
        $trayStationFlyout.removeClass('open');
        $btnStationFlyout.removeClass('open');
    },


}
